export default "__VITE_ASSET__f4363a1f__"